export const LOGIN_ROUTE = "/login";
export const DASHBOARD_ROUTE = "/";
export const EMPLOYEES_ROUTE = "/users";
export const CUSTOMER_LIST__ROUTE = "/customers";
export const CUSTOMER_PROFILE_ROUTE = (id) => CUSTOMER_LIST__ROUTE + "/" + id;
export const FINANCIAL_ROUTE = "/finance";
export const FORMS_ROUTE = "/forms";
export const FORM_SUBMIT_ROUTE = "/form-submit";
export const DOCUMENTS_ROUTES = "/files";
export const FORM_EDIT_ROUTE = (id) => "/form-edits" + "/" + id;
export const FRONT_OFFICE_ROUTE = "/front-office";
export const INQUIRY_LIST = "/inquiry-list";
export const SYSTEM_CONFIGS_ROUTES = "/system-config";
export const CANDIDATE_FORM_ROUTES = "/candidate-forms";
export const CANDIDATE_PROFILE_CREATION = "/profile-creation";
export const CANDIDATE_PROFILE_CREATION_AI = "/profile-creation-ai";
export const CANDIDATE_SHORT_LIST = "/short-list";
export const LEAD_LIST_ROUTE = "/leads";
export const JOB_ORDER_ROUTE = "/job-orders";
export const CVDATA_ROUTE = "/cv-data";
export const CLIENT_ROUTE = "/client-portal";
export const CANDIDATE_ROUTE = "/candidate-portal";
export const CLIENT_HOME_ROUTE = "/client-home";
export const REPORTS_ROUTE = "/reports";